import me from './me';
import pin from './pin';
import profile from './profile';
import general from './general';

const userService = {
  me,
  pin,
  profile,
  general,
};

export default userService;
